<div class="dropdown">
  <button class="btn btn-lg secondary full" [ngClass]="{'active': isActive,'borderless': borderless}" type="button"
    id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
    <span *ngIf="svg"><img src="../../../assets/icon/filter-results-button.svg"></span>
    <span *ngIf="svg !== true">{{title}} ▼</span>
  </button>
  <div class="dropdown-menu  dropdown-menu-right allow-focus full">
    <div class="container m-0 p-0 max">
      <div class="row m-0 p-0" *ngFor="let item of list">
        <div class="col-12 m-0 p-0">
          <label class="checkbox-container">
            <input type="checkbox" id="{{item.value}}" [(ngModel)]="item.checked" (change)="onToggle()">
            <span class="checkmark"></span>{{item.display}}</label>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/element/select-dropdown/select-dropdown.component.html